export default "__VITE_ASSET__6lauhC_t__"